export enum EApiResponseContentType {
  ApplicationJson = 0,
  TextHtml = 1
}
